module.exports = __webpack_public_path__ + "b32d7db260645e7fc5a330d6cd20f48f.png";